import React from 'react';

import PropTypes from 'prop-types';

import { Box, Drawer } from '@mui/material';

import { VIEW_MODE_OPTIONS } from '@common/constants';
import Loading from '../Loading/Loading';
import { selectBackgroundColor } from '@common/providers/ThemeProvider/selectors';

const Layout = ({
  loading = false,
  left = null,
  middle = null,
  right = null,
  top = null,
  isRightDrawerOpen,
  onRightDrawerClose = () => {},
  viewMode,
  setViewMode,
}) => (
  <Box sx={{ display: 'flex' }}>
    <Loading isOpen={loading} />
    <Box
      sx={{
        backgroundColor: selectBackgroundColor,
        p: 1,
        width: '200px',
      }}
    >
      {left}
    </Box>
    <Box>
      <Box width={'100%'} padding='0px 0px'>
        {top}
      </Box>
      <Box sx={{ flexGrow: 1, minWidth: 0, padding: '0px 5px 5px 0px' }}>
        {middle}
      </Box>
      <Drawer
        open={isRightDrawerOpen}
        onClose={() => {
          onRightDrawerClose();
          setViewMode(VIEW_MODE_OPTIONS.DETAILS);
        }}
        anchor='right'
        sx={{
          '& .MuiDrawer-paper': {
            maxWidth: '440px',
            width: '100%',
            boxSizing: 'border-box',
            backgroundColor: (theme) => {
              return theme.palette.background.color;
            },
          },
        }}
      >
        {right}
      </Drawer>
    </Box>
  </Box>
);

Layout.defaultProps = {
  loading: [false, false, false],
  left: null,
  middle: null,
  right: null,
  top: null,
};

Layout.propTypes = {
  loading: PropTypes.arrayOf(PropTypes.bool),
  left: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  middle: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  right: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  top: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

export default Layout;
